<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>Maszyny</h2>
      <ol class="breadcrumb">
        <li>
          <router-link to="/">Home</router-link>
        </li>
        <li class="active">
          <router-link to="/machines">Maszyny</router-link>
        </li>
        <li class="active">
          <strong>Edycja</strong>
        </li>
      </ol>
    </div>
  </div>

  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Opis maszyny</h5>
          </div>

          <div class="form-horizontal">
            <div class="ibox-content">
              <div class="form-group">
                <label class="control-label col-sm-2">Nazwa</label>
                <div class="col-sm-10">
                  <input
                    v-model="machineObj.name"
                    name="name"
                    type="text"
                    class="form-control inputClass"
                    placeholder="Nazwa"
                    required="required"
                  />
                  <div v-if="machineError('name')" class="has-error">
                    <span class="help-block">
                      {{ machineError("name") }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">Model</label>
                <div class="col-sm-10">
                  <input
                    v-model="machineObj.model"
                    name="name"
                    type="text"
                    class="form-control inputClass"
                    placeholder="Model"
                    required="required"
                  />
                  <div v-if="machineError('model')" class="has-error">
                    <span class="help-block">{{ machineError("model") }}</span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">Typ</label>
                <div class="col-sm-10">
                  <input
                    v-model="machineObj.type"
                    name="name"
                    type="text"
                    class="form-control inputClass"
                    placeholder="Typ"
                    required="required"
                  />
                  <div v-if="machineError('type')" class="has-error">
                    <span class="help-block">{{ machineError("type") }}</span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">Koszt</label>
                <div class="col-sm-10">
                  <input
                    v-model="machineObj.cost"
                    name="name"
                    type="text"
                    class="form-control inputClass"
                    placeholder="Koszt"
                    required="required"
                  />
                  <div v-if="machineError('cost')" class="has-error">
                    <span class="help-block">
                      {{ machineError("cost") }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">Max format zadruku</label>
                <div class="col-sm-10 flex-inputs">
                  <div>
                    <input
                      v-model="machineObj.max_print_x"
                      type="text"
                      class="form-control inputClass"
                      placeholder="x"
                      required="required"
                    />
                    <div v-if="machineError('max_print_x')" class="has-error">
                      <span class="help-block">
                        {{ machineError("max_print_x") }}
                      </span>
                    </div>
                  </div>
                  <div>
                    <input
                      v-model="machineObj.max_print_y"
                      type="text"
                      class="form-control inputClass"
                      placeholder="y"
                      required="required"
                    />
                    <div v-if="machineError('max_print_y')" class="has-error">
                      <span class="help-block">
                        {{ machineError("max_print_y") }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">Min format zadruku</label>
                <div class="col-sm-10 flex-inputs">
                  <div>
                    <input
                      v-model="machineObj.min_print_x"
                      type="text"
                      class="form-control inputClass"
                      placeholder="x"
                      required="required"
                    />
                    <div v-if="machineError('min_print_x')" class="has-error">
                      <span class="help-block">
                        {{ machineError("min_print_x") }}
                      </span>
                    </div>
                  </div>
                  <div>
                    <input
                      v-model="machineObj.min_print_y"
                      type="text"
                      class="form-control inputClass"
                      placeholder="y"
                      required="required"
                    />
                    <div v-if="machineError('min_print_y')" class="has-error">
                      <span class="help-block">
                        {{ machineError("min_print_y") }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">Format matrycy</label>
                <div class="col-sm-10 flex-inputs">
                  <div>
                    <input
                      v-model="machineObj.matrix_x"
                      type="text"
                      class="form-control inputClass"
                      placeholder="x"
                      required="required"
                    />
                    <div v-if="machineError('matrix_x')" class="has-error">
                      <span class="help-block">
                        {{ machineError("matrix_x") }}
                      </span>
                    </div>
                  </div>
                  <div>
                    <input
                      v-model="machineObj.matrix_y"
                      type="text"
                      class="form-control inputClass"
                      placeholder="y"
                      required="required"
                    />
                    <div v-if="machineError('matrix_y')" class="has-error">
                      <span class="help-block">
                        {{ machineError("matrix_y") }}
                      </span>
                    </div>
                  </div>
                  <div>
                    <input
                      v-model="machineObj.matrix_cost_per_m2"
                      type="text"
                      class="form-control inputClass"
                      placeholder="Koszt [m2]"
                      required="required"
                    />
                    <div
                      v-if="machineError('matrix_cost_per_m2')"
                      class="has-error"
                    >
                      <span class="help-block">
                        {{ machineError("matrix_cost_per_m2") }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="canViewAction" class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Czynności</h5>
          </div>
          <div class="form-horizontal">
            <div class="ibox-content">
              <button
                v-if="canAddAction"
                @click="openAddAction"
                class="btn btn-sm btn-primary"
              >
                Dodaj
              </button>
              <EasyDataTable
                :headers="headers"
                :items="machineObj.actions"
                :loading="loading"
                alternating
              >
                <template #item-actions="item">
                  <button
                    v-if="canChangeAction"
                    @click="editAction(item)"
                    class="btn btn-warning btn-xs"
                  >
                    <i class="fa fa-pencil" aria-hidden="true"></i>
                  </button>
                  <button
                    v-if="canDeleteAction"
                    @click="removeAction(item)"
                    class="btn btn-danger btn-xs"
                  >
                    <i class="fa fa-trash"></i>
                  </button>
                </template>
                <template #item-is_work_preview="item">
                  <i v-if="item.is_work_preview" class="fa fa-check"></i>
                  <i v-else class="fa fa-times"></i>
                </template>
                <template #item-is_mounting_info="item">
                  <i v-if="item.is_mounting_info" class="fa fa-check"></i>
                  <i v-else class="fa fa-times"></i>
                </template>
                <template #item-is_use_codes_verification="item">
                  <i v-if="item.is_use_codes_verification" class="fa fa-check">
                  </i>
                  <i v-else class="fa fa-times"></i>
                </template>
                <template #item-is_use_codes_verification_print="item">
                  <i
                    v-if="item.is_use_codes_verification_print"
                    class="fa fa-check"
                  >
                  </i>
                  <i v-else class="fa fa-times"></i>
                </template>
                <template #item-is_assembly_codes_verification="item">
                  <i
                    v-if="item.is_assembly_codes_verification"
                    class="fa fa-check"
                  >
                  </i>
                  <i v-else class="fa fa-times"></i>
                </template>
              </EasyDataTable>
            </div>
          </div>
        </div>
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Konfiguracja maszyny</h5>
          </div>

          <div class="form-horizontal">
            <div class="ibox-content">
              <div class="form-group">
                <label class="control-label col-sm-2">Zdjęcie</label>
                <div class="col-sm-2">
                  <picture-input
                    ref="pictureInput"
                    width="300"
                    height="300"
                    margin="16"
                    accept="image/jpeg,image/png"
                    size="10"
                    :prefill="machineObj?.image"
                    button-class="btn"
                    :custom-strings="{
                      upload: '<h1>Uploading!</h1>',
                      drag: 'Drag & Drop',
                    }"
                    @change="changePhoto"
                  >
                  </picture-input>
                </div>
              </div>
              <div class="form-group">
                <div class="col-sm-4 col-sm-offset-2">
                  <router-link class="btn btn-white" to="/machines">
                    Anuluj
                  </router-link>
                  <button
                    v-if="canChangeMachine"
                    @click="save"
                    class="btn btn-primary"
                  >
                    Zapisz
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-if="mActions" class="modal-dialog abs">
    <div class="modal-content">
      <div class="inmodal">
        <div class="modal-header">
          <h4 class="modal-title">
            {{ isEdit ? "Edytuj czynność maszyny" : "Dodaj czynność maszyny" }}
          </h4>
        </div>
        <div class="modal-body" style="max-height: 70vh; overflow-y: auto">
          <div class="form-horizontal">
            <div class="ibox-content">
              <div class="form-group">
                <label class="control-label col-sm-2">Nazwa</label>
                <div class="col-sm-10">
                  <input
                    v-model="actions.name"
                    name="name"
                    type="text"
                    class="form-control inputClass"
                    placeholder="Nazwa"
                    required="required"
                  />
                  <div
                    v-if="!actions.name && showModalErrors"
                    class="has-error"
                  >
                    <span class="help-block">To pole musi być wypełnione!</span>
                  </div>
                  <div v-else-if="actionError('name')" class="has-error">
                    <span class="help-block">{{ actionError("name") }}</span>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div class="col-sm-offset-2 col-sm-10">
                  <div class="checkbox checkbox-primary">
                    <label>
                      <input
                        v-model="actions.is_work_preview"
                        name="is_work_preview"
                        type="checkbox"
                      />
                      <span>Podgląd pracy</span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div class="col-sm-offset-2 col-sm-10">
                  <div class="checkbox checkbox-primary">
                    <label>
                      <input
                        v-model="actions.is_mounting_info"
                        name="is_mounting_info"
                        type="checkbox"
                      />
                      <span>Informacje o montażu</span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div class="col-sm-offset-2 col-sm-10">
                  <div class="checkbox checkbox-primary">
                    <label>
                      <input
                        v-model="actions.is_use_codes_verification"
                        name="is_use_codes_verification"
                        type="checkbox"
                      />
                      <span>Weryfikacja kodów użytków</span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div class="col-sm-offset-2 col-sm-10">
                  <div class="checkbox checkbox-primary">
                    <label>
                      <input
                        v-model="actions.is_use_codes_verification_print"
                        name="is_use_codes_verification_print"
                        type="checkbox"
                      />
                      <span>Drukowanie i weryfikacja kodów użytków</span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div class="col-sm-offset-2 col-sm-10">
                  <div class="checkbox checkbox-primary">
                    <label>
                      <input
                        v-model="actions.is_assembly_codes_verification"
                        name="is_use_codes_verification_print"
                        type="checkbox"
                      />
                      <span>Weryfikacja kodu montażu</span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">Opis</label>
                <div class="col-sm-10 QuillEditor-box">
                  <QuillEditor
                    theme="snow"
                    contentType="html"
                    v-model:content="actions.description"
                  />
                  <div v-if="actionError('description')" class="has-error">
                    <span class="help-block">
                      {{ actionError("description") }}
                    </span>
                  </div>
                </div>
              </div>

              <!-- Wydajność -->
              <div class="form-group">
                <label class="control-label col-sm-2">
                  Wydajność [arkusz/h]
                </label>
                <div class="col-sm-10">
                  <input
                    v-model="actions.sheets_per_hour"
                    name="sheets_per_hour"
                    type="number"
                    class="form-control inputClass"
                    placeholder="Wydajność w arkuszach na godzinę"
                    min="0"
                    step="0.01"
                  />
                  <div v-if="actionError('sheets_per_hour')" class="has-error">
                    <span class="help-block">
                      {{ actionError("sheets_per_hour") }}
                    </span>
                  </div>
                </div>
              </div>

              <!-- Koszty eksploatacyjne stałe -->
              <div class="form-group">
                <label class="control-label col-sm-2"
                  >Koszty eksploatacyjne stałe</label
                >
                <div class="col-sm-10">
                  <button
                    @click="addActionOperationalCost"
                    class="btn btn-default"
                  >
                    Dodaj koszt stały
                  </button>
                </div>
              </div>
              <div
                v-for="(cost, key) in actions.operational_costs"
                :key="key"
                class="form-group"
              >
                <div class="col-sm-10 col-sm-offset-2">
                  <div class="cost-input-row">
                    <div class="cost-type-selector">
                      <Multiselect
                        v-model="actions.operational_costs[key].type"
                        mode="single"
                        placeholder="Typ"
                        track-by="name"
                        label="name"
                        :close-on-select="true"
                        :searchable="true"
                        :resolve-on-blur="false"
                        :options="units"
                        :object="true"
                        :filter="customFilter"
                        class="cost-multiselect"
                        @open="() => {}"
                        @select="() => {}"
                      >
                        <template #option="{ option }">
                          <div class="option-with-delete">
                            <button
                              v-if="canDeleteUnit"
                              type="button"
                              class="btn btn-sm btn-danger delete-btn"
                              @click.stop="confirmDeleteUnit(option)"
                              title="Usuń jednostkę"
                            >
                              ×
                            </button>
                            <span class="option-text">
                              {{ option.name }} ({{ option.symbol }})
                            </span>
                          </div>
                        </template>
                      </Multiselect>
                      <button
                        v-if="canAddUnit"
                        type="button"
                        class="btn btn-sm btn-success add-unit-btn"
                        @click="showUnitModal = true"
                        title="Dodaj nową jednostkę"
                      >
                        +
                      </button>
                      <div v-if="costError(key, 'unit')" class="has-error">
                        <span class="help-block">
                          {{ costError(key, "unit") }}
                        </span>
                      </div>
                    </div>
                    <div class="cost-name-input">
                      <input
                        v-model="actions.operational_costs[key].name"
                        name="name"
                        type="text"
                        class="form-control"
                        placeholder="Nazwa"
                        required="required"
                      />
                      <div v-if="costError(key, 'name')" class="has-error">
                        <span class="help-block">
                          {{ costError(key, "name") }}
                        </span>
                      </div>
                    </div>
                    <div class="cost-amount-input">
                      <input
                        v-model="actions.operational_costs[key].amount"
                        name="amount"
                        type="number"
                        class="form-control"
                        placeholder="Wartość"
                        required="required"
                        step="0.01"
                        min="0"
                      />
                      <div v-if="costError(key, 'amount')" class="has-error">
                        <span class="help-block">
                          {{ costError(key, "amount") }}
                        </span>
                      </div>
                    </div>
                    <div
                      v-if="actions.operational_costs.length > 1"
                      class="cost-remove-btn"
                    >
                      <button
                        @click="removeActionOperationalCost(key)"
                        class="btn btn-danger btn-sm"
                        title="Usuń koszt"
                      >
                        <i class="fa fa-times"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="hr-line-dashed"></div>
              <div class="form-group">
                <label class="control-label col-sm-2">
                  Checklista przed rozpoczęciem
                </label>
                <div class="col-sm-10">
                  <input
                    v-model="checklist_before_start"
                    name="checklist_before_start"
                    type="text"
                    class="form-control inputClass"
                    placeholder="Checklista przed rozpoczęciem"
                    v-on:keyup.enter="addToChecklist(1)"
                  />
                  <ul class="list-group">
                    <li
                      v-for="(item, key) in actions.checklist_before_start"
                      class="list-group-item"
                      :key="key"
                    >
                      <span data-ng-bind="item">{{ item }}</span>
                      <a
                        @click="removeFromChecklist(1, key)"
                        class="text-danger"
                      >
                        <i class="fa fa-times" aria-hidden="true"></i>
                        <span>usuń</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="form-group">
                <label class="control-label col-sm-2">
                  Checklista przed zakończeniem
                </label>
                <div class="col-sm-10">
                  <input
                    v-model="checklist_before_end"
                    name="checklist_before_end"
                    type="text"
                    class="form-control inputClass"
                    placeholder="Checklista przed zakończeniem"
                    required="required"
                    v-on:keyup.enter="addToChecklist(0)"
                  />
                  <ul class="list-group">
                    <li
                      v-for="(item, key) in actions.checklist_before_end"
                      class="list-group-item"
                      :key="key"
                    >
                      <span data-ng-bind="item">{{ item }}</span>
                      <a
                        @click="removeFromChecklist(0, key)"
                        class="text-danger"
                      >
                        <i class="fa fa-times" aria-hidden="true"></i>
                        <span>usuń</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button @click="cancelAction()" class="btn btn-white">Anuluj</button>
          <button v-if="isEdit" @click="saveAction()" class="btn btn-primary">
            Zapisz
          </button>
          <button v-else @click="addAction()" class="btn btn-primary">
            Dodaj
          </button>
        </div>
      </div>
    </div>
  </div>
  <div v-if="mActions" @click="cancelAction" class="modal-backdrop"></div>

  <!-- Modal for creating new unit -->
  <div
    v-if="showUnitModal"
    class="modal fade show unit-modal"
    style="display: block; background-color: rgba(0, 0, 0, 0.5)"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Dodaj nową jednostkę</h4>
          <button type="button" class="close" @click="showUnitModal = false">
            <span>&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label>Nazwa jednostki</label>
            <input
              v-model="newUnit.name"
              type="text"
              class="form-control"
              placeholder="np. Kilowatogodzina"
            />
          </div>
          <div class="form-group">
            <label>Symbol</label>
            <input
              v-model="newUnit.symbol"
              type="text"
              class="form-control"
              placeholder="np. kWh"
            />
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            @click="showUnitModal = false"
          >
            Anuluj
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click="createUnit"
            :disabled="!newUnit.name || !newUnit.symbol"
          >
            Dodaj jednostkę
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal potwierdzenia usuwania jednostki -->
  <div
    v-if="showDeleteConfirmModal"
    class="modal fade show delete-modal"
    style="display: block; background-color: rgba(0, 0, 0, 0.5)"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Potwierdź usunięcie</h4>
          <button
            type="button"
            class="close"
            @click="showDeleteConfirmModal = false"
          >
            <span>&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p>
            Czy na pewno chcesz usunąć jednostkę
            <strong>{{ selectedUnitForDelete?.name }}</strong>
            ({{ selectedUnitForDelete?.symbol }})?
          </p>
          <p class="text-danger">
            <small>Ta operacja nie może być cofnięta.</small>
          </p>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            @click="showDeleteConfirmModal = false"
          >
            Anuluj
          </button>
          <button
            type="button"
            class="btn btn-danger"
            @click="executeDeleteUnit"
          >
            Usuń
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, ref, watch, onMounted } from "vue";
import { useStore } from "vuex";
import { hasPermission } from "../../permissions";
import {
  collectionItemErrors,
  fieldError,
  firstServerError,
} from "../../serverErrors";
import {
  machineactionPermissionsConst,
  machineErrorLabelsConst,
  machinePermissionsConst,
  unitPermissionsConst,
} from "../../constants/productionConstants";
import router from "../../router/router";
import { useRoute } from "vue-router";
import PictureInput from "vue-picture-input";
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";

export default {
  name: "MachinesEdit",
  mixins: [],
  components: {
    PictureInput,
    Multiselect,
  },
  props: {},

  setup() {
    const actions = ref({
      name: "",
      is_mounting_info: false,
      is_work_preview: false,
      is_use_codes_verification_print: false,
      is_use_codes_verification: false,
      is_assembly_codes_verification: false,
      checklist_before_start: [],
      checklist_before_end: [],
      sheets_per_hour: 0,
      unit: null,
      operational_costs: [
        {
          name: "",
          type: "",
          amount: 0,
        },
      ],
    });
    const checklist_before_end = ref("");
    const checklist_before_start = ref("");
    const units = ref([]);
    const showUnitModal = ref(false);
    const newUnit = ref({
      name: "",
      symbol: "",
    });
    const showDeleteConfirmModal = ref(false);
    const selectedUnitForDelete = ref(null);
    const machineObj = ref({
      name: "",
      model: "",
      type: "",
      cost: "",
      image: "",
      max_print_x: "",
      max_print_y: "",
      min_print_x: "",
      min_print_y: "",
      matrix_x: "",
      matrix_y: "",
      matrix_cost_per_m2: "",
      actions: [],
    });
    const errorsAdminData = ref();
    const mActions = ref(false);
    const isEdit = ref(false);
    const editIndex = ref();
    const showErrors = ref(false);
    const showModalErrors = ref(false);
    const store = useStore();

    const machineError = (field) =>
      fieldError(errorsAdminData.value?.data, field);

    // Errors of the nested action serializer come back as a list aligned with
    // the actions that were sent, so they can only be matched to the action the
    // modal currently has open. A brand new action was not part of the request
    // yet, hence nothing to show for it.
    const openActionErrors = computed(() => {
      if (!isEdit.value) {
        return {};
      }

      return collectionItemErrors(
        errorsAdminData.value?.data,
        "actions",
        editIndex.value
      );
    });

    const actionError = (field) => fieldError(openActionErrors.value, field);

    const costError = (index, field) =>
      fieldError(
        collectionItemErrors(openActionErrors.value, "costs", index),
        field
      );

    const canChangeMachine = computed(() =>
      hasPermission(machinePermissionsConst.update)
    );
    // Machine actions are a separate model - the old panel hides the section
    // without the view permission and gates its buttons with the action ones.
    const canViewAction = computed(() =>
      hasPermission(machineactionPermissionsConst.view)
    );
    const canAddAction = computed(() =>
      hasPermission(machineactionPermissionsConst.add)
    );
    const canChangeAction = computed(() =>
      hasPermission(machineactionPermissionsConst.update)
    );
    const canDeleteAction = computed(() =>
      hasPermission(machineactionPermissionsConst.delete)
    );
    // Units are shared by machines and printing machines, with permissions of
    // their own.
    const canAddUnit = computed(() => hasPermission(unitPermissionsConst.add));
    const canDeleteUnit = computed(() =>
      hasPermission(unitPermissionsConst.delete)
    );
    const updateMachinesData = computed(
      () => store.getters.getUpdateMachinesData
    );
    const machineData = computed(() => store.getters.getMachineData);
    const unitsData = computed(() => store.getters.getUnitsData);

    let headers = [
      { text: "Nazwa", value: "name", sortable: true },
      { text: "Podgląd pracy", value: "is_work_preview", sortable: true },
      {
        text: "Informacje o montażu",
        value: "is_mounting_info",
        sortable: true,
      },
      {
        text: "Weryfikacja kodów użytkowników",
        value: "is_use_codes_verification",
        sortable: true,
      },
      {
        text: "Drukowanie i weryfikacja kodów użytkowników",
        value: "is_use_codes_verification_print",
        sortable: true,
      },
      {
        text: "Weryfikacja kodu montażu",
        value: "is_assembly_codes_verification",
        sortable: true,
      },
      { text: "Akcje", value: "actions" },
    ];

    const route = useRoute();
    store.dispatch("getMachine", { pk: route.params.pk });

    onMounted(() => {
      loadUnits();
    });

    const save = () => {
      if (!canChangeMachine.value) {
        return;
      }
      showErrors.value = true;
      machineObj.value.actions = machineObj.value.actions.map((action) => {
        let mappedOperationalCosts = [];
        if (
          action.operational_costs &&
          Array.isArray(action.operational_costs)
        ) {
          mappedOperationalCosts = action.operational_costs.map((cost) => {
            let unitId = null;
            if (cost.type && typeof cost.type === "object" && cost.type.pk) {
              unitId = cost.type.pk;
            } else if (cost.type && typeof cost.type === "number") {
              unitId = cost.type;
            }
            const result = {
              name: cost.name,
              amount: cost.amount,
              unit: unitId,
            };
            return result;
          });
        }

        // eslint-disable-next-line no-unused-vars
        const { operational_costs, unit, ...actionWithoutOperationalCosts } =
          action;
        return {
          ...actionWithoutOperationalCosts,
          costs: mappedOperationalCosts,
        };
      });
      store.dispatch("updateMachines", machineObj.value);
    };

    const addAction = () => {
      if (!canAddAction.value) {
        return;
      }
      if (actions.value.name) {
        machineObj.value.actions.push(actions.value);
        mActions.value = false;
        resetAction();
      } else {
        showModalErrors.value = true;
      }
    };

    const saveAction = () => {
      if (!canChangeAction.value) {
        return;
      }
      if (actions.value.name) {
        machineObj.value.actions[editIndex.value] = actions.value;
        mActions.value = false;
        isEdit.value = false;
        resetAction();
      } else {
        showModalErrors.value = true;
      }
    };

    const resetAction = () => {
      actions.value = {
        name: "",
        is_mounting_info: false,
        is_work_preview: false,
        is_use_codes_verification_print: false,
        is_use_codes_verification: false,
        is_assembly_codes_verification: false,
        checklist_before_start: [],
        checklist_before_end: [],
        sheets_per_hour: 0,
        unit: null,
        operational_costs: [
          {
            name: "",
            type: "",
            amount: 0,
          },
        ],
      };
    };

    const removeAction = (item) => {
      if (!canDeleteAction.value) {
        return;
      }
      var index = machineObj.value.actions
        .map(function (e) {
          return e.name;
        })
        .indexOf(item.name);
      machineObj.value.actions.splice(index, 1);
    };

    const editAction = (item) => {
      if (!canChangeAction.value) {
        return;
      }
      mActions.value = true;
      isEdit.value = true;

      if (units.value.length === 0) {
        loadUnits();
        const checkUnits = () => {
          if (units.value.length > 0) {
            mapCostsAndSetActions(item);
          } else {
            setTimeout(checkUnits, 100);
          }
        };
        checkUnits();
      } else {
        mapCostsAndSetActions(item);
      }

      editIndex.value = machineObj.value.actions
        .map(function (e) {
          return e.name;
        })
        .indexOf(item.name);
    };

    const mapCostsAndSetActions = (item) => {
      let mappedOperationalCosts = [];
      if (item.costs && Array.isArray(item.costs) && item.costs.length > 0) {
        mappedOperationalCosts = item.costs.map((cost) => {
          let processedType = "";
          if (cost.unit && typeof cost.unit === "object") {
            processedType = cost.unit;
          } else if (cost.unit) {
            const foundUnit = units.value.find((u) => u.pk === cost.unit);
            processedType = foundUnit || "";
          }
          const result = {
            name: cost.name || "",
            type: processedType,
            amount: cost.amount || 0,
          };
          return result;
        });
      }

      if (mappedOperationalCosts.length === 0) {
        mappedOperationalCosts = [
          {
            name: "",
            type: "",
            amount: 0,
          },
        ];
      }

      actions.value = {
        ...item,
        sheets_per_hour: item.sheets_per_hour || 0,
        unit: item.unit || null,
        operational_costs: mappedOperationalCosts,
      };
    };

    const addToChecklist = (type) => {
      if (type === 1) {
        if (checklist_before_start.value !== "") {
          actions.value.checklist_before_start.push(
            checklist_before_start.value
          );
          checklist_before_start.value = "";
        }
      } else {
        if (checklist_before_end.value !== "") {
          actions.value.checklist_before_end.push(checklist_before_end.value);
          checklist_before_end.value = "";
        }
      }
    };

    const removeFromChecklist = (type, key) => {
      if (type === 1) {
        actions.value.checklist_before_start.splice(key, 1);
      } else {
        actions.value.checklist_before_end.splice(key, 1);
      }
    };

    const changePhoto = (image) => {
      if (image.srcElement?.files[0]) {
        machineObj.value.image = image.srcElement?.files[0];
      }
    };

    const loadUnits = async () => {
      try {
        store.dispatch("getUnits");
      } catch (error) {
        console.error("Error loading units:", error);
      }
    };

    const customFilter = (option, label, search) => {
      if (!search) return true;
      const searchLower = search.toLowerCase();
      return (
        option.name.toLowerCase().includes(searchLower) ||
        option.symbol.toLowerCase().includes(searchLower)
      );
    };

    const addActionOperationalCost = () => {
      actions.value.operational_costs.push({
        name: "",
        type: "",
        amount: 0,
      });
    };

    const removeActionOperationalCost = (index) => {
      actions.value.operational_costs.splice(index, 1);
    };

    const createUnit = async () => {
      if (!canAddUnit.value) {
        return;
      }
      try {
        await store.dispatch("createUnit", newUnit.value);
      } catch (error) {
        console.error("Error creating unit:", error);
      }
    };

    const deleteUnit = async (unitId) => {
      if (!canDeleteUnit.value) {
        return;
      }
      try {
        await store.dispatch("deleteUnit", unitId);
      } catch (error) {
        console.error("Error deleting unit:", error);
      }
    };

    const confirmDeleteUnit = (unit) => {
      if (!canDeleteUnit.value) {
        return;
      }
      selectedUnitForDelete.value = unit;
      showDeleteConfirmModal.value = true;
    };

    const executeDeleteUnit = async () => {
      if (selectedUnitForDelete.value) {
        await deleteUnit(selectedUnitForDelete.value.pk);
        showDeleteConfirmModal.value = false;
        selectedUnitForDelete.value = null;
      }
    };

    // Both the add button and every way of closing the modal go through these,
    // so the modal never opens carrying the mode, the data or the validation
    // state of whatever was edited before it.
    const openAddAction = () => {
      if (!canAddAction.value) {
        return;
      }

      isEdit.value = false;
      editIndex.value = undefined;
      showModalErrors.value = false;
      resetAction();
      mActions.value = true;
    };

    const cancelAction = () => {
      mActions.value = false;
      isEdit.value = false;
      editIndex.value = undefined;
      showModalErrors.value = false;
      resetAction();
    };

    watch(
      () => updateMachinesData.value,
      function (newValue) {
        if (newValue.status === 200) {
          router.push({ name: "MachinesList", path: "/machines" }).then(() => {
            store.dispatch("showToaster", {
              type: "success",
              content: "Dane zostały zaktualizowane",
            });
          });
        } else {
          store.dispatch("showToaster", {
            type: "error",
            content: firstServerError(
              newValue.data,
              "Nie udało się zaktualizować maszyny",
              machineErrorLabelsConst
            ),
          });
          errorsAdminData.value = newValue;
        }
      }
    );

    watch(
      () => machineData.value,
      function (newValue) {
        machineObj.value = newValue.data;
      }
    );

    watch(
      () => unitsData.value,
      function (newValue) {
        units.value = (newValue?.data?.results || []).map((unit) => ({
          ...unit,
          value: unit.pk,
        }));
      },
      { deep: true }
    );

    // Watcher dla createUnitData
    const createUnitData = computed(() => store.getters.getCreateUnitData);
    const deleteUnitData = computed(() => store.getters.getDeleteUnitData);

    watch(
      () => createUnitData.value,
      function (newValue) {
        if (newValue?.status === 201) {
          showUnitModal.value = false;
          newUnit.value = { name: "", symbol: "" };
          store.dispatch("getUnits");
          store.dispatch("showToaster", {
            type: "success",
            content: "Nowa jednostka została dodana",
          });
        } else if (newValue?.status && newValue.status !== 201) {
          store.dispatch("showToaster", {
            type: "error",
            content: "Błąd podczas dodawania jednostki",
          });
        }
      }
    );

    watch(
      () => deleteUnitData.value,
      function (newValue) {
        if (newValue?.status === 204) {
          showDeleteConfirmModal.value = false;
          selectedUnitForDelete.value = null;
          store.dispatch("getUnits");
          store.dispatch("showToaster", {
            type: "success",
            content: "Jednostka została usunięta pomyślnie!",
          });
        } else if (newValue?.status && newValue.status !== 204) {
          store.dispatch("showToaster", {
            type: "error",
            content:
              "Błąd podczas usuwania jednostki: " +
              (newValue?.data?.detail || "Nieznany błąd"),
          });
        }
      }
    );

    return {
      canChangeMachine,
      canViewAction,
      canAddAction,
      canChangeAction,
      canDeleteAction,
      canAddUnit,
      canDeleteUnit,
      machineObj,
      machineError,
      actionError,
      costError,
      showErrors,
      save,
      mActions,
      actions,
      checklist_before_end,
      checklist_before_start,
      addToChecklist,
      removeFromChecklist,
      addAction,
      headers,
      showModalErrors,
      removeAction,
      editAction,
      saveAction,
      isEdit,
      changePhoto,
      loadUnits,
      units,
      customFilter,
      addActionOperationalCost,
      removeActionOperationalCost,
      openAddAction,
      cancelAction,
      mapCostsAndSetActions,
      showUnitModal,
      newUnit,
      showDeleteConfirmModal,
      selectedUnitForDelete,
      createUnit,
      confirmDeleteUnit,
      executeDeleteUnit,
    };
  },
  computed: {},
};
</script>

<style scoped>
.modal-dialog.abs {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 21000;
  width: 80%;
  max-width: 800px;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 20990;
}

.modal {
  z-index: 1050;
}
.modal.show {
  display: block;
}

.multiselect-with-buttons {
  display: flex;
  align-items: center;
  gap: 5px;
}

.add-unit-btn {
  flex-shrink: 0;
  height: 38px;
  width: 38px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 16px;
}

/* Dostosowanie Multiselect */
:deep(.multiselect) {
  min-height: 38px;
}

:deep(.multiselect-dropdown) {
  max-height: 200px;
}

:deep(.multiselect-option) {
  padding: 8px 12px;
}

:deep(.multiselect-option:hover) {
  background-color: #f8f9fa;
}

/* Flexible multiselect styling */
.flexible-multiselect {
  min-width: 200px;
  max-width: 400px;
}

:deep(.flexible-multiselect .multiselect-dropdown) {
  min-width: 300px;
  max-width: 500px;
}

:deep(.flexible-multiselect .multiselect-option) {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

:deep(.flexible-multiselect .multiselect-option.is-selected) {
  color: #333 !important;
}

:deep(.flexible-multiselect .multiselect-option.is-selected:hover) {
  color: #333 !important;
}

.option-with-delete {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.delete-btn {
  background: none;
  border: none;
  color: #dc3545;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  padding: 0;
  margin-right: 8px;
  line-height: 1;
}

.delete-btn:hover {
  color: #c82333;
}

.option-text {
  flex: 1;
}

.flex-inputs {
  display: flex;
  align-items: center;
  gap: 10px;
}

.mr-20 {
  margin-right: 20px;
}

/* Style dla kosztów eksploatacyjnych */
.cost-input-row {
  display: flex;
  align-items: flex-start;
  gap: 15px;
  flex-wrap: nowrap;
}

.cost-type-selector {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 200px;
  flex-shrink: 0;
}

.cost-name-input {
  min-width: 180px;
  flex: 1;
  max-width: 200px;
}

.cost-name-input input {
  width: 100%;
  min-width: 180px;
}

.cost-amount-input {
  min-width: 100px;
  flex: 1;
  max-width: 150px;
}

.cost-amount-input input {
  width: 100%;
  min-width: 100px;
}

.cost-remove-btn {
  flex-shrink: 0;
  margin-top: 2px;
}

.cost-multiselect {
  min-width: 180px;
  max-width: 200px;
}

/* Style dla modali */
.unit-modal,
.delete-modal {
  z-index: 22000 !important;
}

.unit-modal .modal-dialog,
.delete-modal .modal-dialog {
  z-index: 22001 !important;
}

.unit-modal .modal-content,
.delete-modal .modal-content {
  z-index: 22002 !important;
}

/* Poprawki dla przycisków */
.add-unit-btn {
  flex-shrink: 0;
  height: 38px;
  width: 38px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 16px;
  margin-left: 5px;
}

.delete-btn {
  background: none;
  border: none;
  color: #dc3545;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  padding: 0;
  margin-right: 8px;
  line-height: 1;
}

.delete-btn:hover {
  color: #c82333;
}

.option-with-delete {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.option-text {
  flex: 1;
}

/* Kontrast na hover dla domyślnego przycisku */
.btn.btn-default:hover {
  background-color: #f5f5f5;
  color: #333;
  border-color: #e0e0e0;
}

/* Hover dla zaznaczonej wartości w multiselect */
:deep(.multiselect-option.is-selected:hover) {
  background-color: #e3f2fd !important;
  color: #1976d2 !important;
}

:deep(.multiselect-option:hover) {
  background-color: #f5f5f5 !important;
  color: #333 !important;
}
</style>
